import React from 'react';
import { Check, XCircle, AlertCircle } from 'lucide-react';

/**
 * Inline validation indicator
 * Shows green checkmark for valid, red X for invalid, yellow warning for warnings
 */
const ValidationIndicator = ({ isValid, isInvalid, warningMessage, successMessage }) => {
  if (isValid && !isInvalid) {
    return (
      <div className="absolute right-3 top-1/2 transform -translate-y-1/2 flex items-center gap-1">
        <Check className="h-5 w-5 text-green-500" />
        {successMessage && (
          <span className="text-xs text-green-600">{successMessage}</span>
        )}
      </div>
    );
  }
  
  if (isInvalid) {
    return (
      <div className="absolute right-3 top-1/2 transform -translate-y-1/2">
        <XCircle className="h-5 w-5 text-red-500" />
      </div>
    );
  }
  
  if (warningMessage) {
    return (
      <div className="absolute right-3 top-1/2 transform -translate-y-1/2">
        <AlertCircle className="h-5 w-5 text-yellow-500" title={warningMessage} />
      </div>
    );
  }
  
  return null;
};

export default ValidationIndicator;
